import { SNACKBAR_TIMEOUT } from '../../../door-project/const';

type TSnackbarDictionaryItem = {
  id: string;
  title: string;
  content: string;
  type: string;
  time: boolean;
  timeout?: number;
  closeButton?: boolean;
  icon?: true;
};

type TSnackbarDictionary = {
  [key: string]: TSnackbarDictionaryItem;
};

export enum TSnackbarDictionaryKeys {
  CALCULATION_ERROR = 'calculationError',
  SUCCESSFULY_ADD_TO_CART = 'successfulyAddedToCart',
  ERROR_ADD_TO_CART = 'errorAddToCart',
  SAVE_DOOR_PROJECT_CLIENT_ERROR = 'saveDoorProjectClientError',
  SAVE_DOOR_PROJECT_SERVER_ERROR = 'saveDoorProjectServerError',
}

export const SNACKBARS_DICTIONARY: TSnackbarDictionary = {
  calculationError: {
    id: `${TSnackbarDictionaryKeys.CALCULATION_ERROR}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось расчитать товары',
    type: 'alert',
    time: true,
  },
  serviceError: {
    id: `${TSnackbarDictionaryKeys.CALCULATION_ERROR}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось перейти к оформлению замера',
    type: 'alert',
    time: true,
  },
  successfulyAddedToCart: {
    id: `${TSnackbarDictionaryKeys.SUCCESSFULY_ADD_TO_CART}`,
    title: 'Товары добавлены в корзину',
    content: 'Перейдите в корзину для оформления или продолжите покупки',
    type: 'success',
    time: true,
  },
  errorAddToCart: {
    id: `${TSnackbarDictionaryKeys.ERROR_ADD_TO_CART}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось добавить товары в корзину',
    type: 'alert',
    time: true,
  },
  saveDoorProjectClientError: {
    id: `${TSnackbarDictionaryKeys.SAVE_DOOR_PROJECT_CLIENT_ERROR}`,
    title: 'Не удалось сохранить параметры двери',
    content: 'Попробуйте ещё раз',
    type: 'error',
    time: true,
    timeout: SNACKBAR_TIMEOUT,
    closeButton: true,
    icon: true,
  },
  saveDoorProjectServerError: {
    id: `${TSnackbarDictionaryKeys.SAVE_DOOR_PROJECT_SERVER_ERROR}`,
    title: 'Что-то пошло не так',
    content: 'Попробуйте ещё раз',
    type: 'error',
    time: true,
    timeout: SNACKBAR_TIMEOUT,
    closeButton: true,
    icon: true,
  },
};
